<template>
  <div style="width: 100%;height: 100%;" class="body2">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="policyServiceIndex"></headers>
          <div class="position">
            <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <span>政策知识</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>

        <div class="wraper">
          <div class="policy_search_part">
            <div class="policy_search">
              <input name="" v-model="searchTitle" type="text" placeholder="请输入标题" style="width: 570px;font-size:14px;">
              <button  style="width: 77px;"  @click="search()"></button>
            </div>
            <p style="display: none;"><a href="javascript:void(0)">社会救助</a><a href="javascript:void(0)">社会福利</a><a href="javascript:void(0)">社会事务</a><a href="javascript:void(0)">中央文件</a><a href="javascript:void(0)">地方文件</a></p>
            <p></p>
          </div>

          <div class="clear"></div>
          <div class="aaa" style="padding-top: 40px;">
            <template>
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="政策文件" name="first">
                  <div class="policy_con" style="margin-top: -10px">
                    <div class="policy_left">
                      <div class="policy_left1" style="display: none;">
                        <h2 class="tit tit3">目录导航</h2>
                        <p><input  type="text" placeholder="请输入政策标题/文号/摘要等关键字"></p>
                      </div>
                      <div class="policy_left2">
                        <ul>
                          <li>目录导航</li>
                        </ul>
                        <el-tree :data="treeData" :props="defaultProps" :default-expand-all="true" :highlight-current="true" @node-click="handleNodeClick"></el-tree>
                      </div>
                    </div>
                    <div class="policy_right">
                      <div class="policy_right1" style="display: none">
                        <h2 class="tit tit4">数据筛选</h2>
                        <p>
                          <span>排序: <a href="javascript:void(0)">相关热度</a><a href="javascript:void(0)">按时间</a></span>
                          <span>搜索位置: <a href="javascript:void(0)">全文</a><a href="javascript:void(0)">标题</a></span>
                          <span>日期筛选: <a href="javascript:void(0)">一周内</a><a href="javascript:void(0)">一月内</a><a href="javascript:void(0)">一年内</a><a href="javascript:void(0)">不限</a></span>
                        </p>
                      </div>
                      <div class="policy_right2">
                        <h2 class="tit tit5">政策文件<div style="float: right;">
                  <span>发布单位：
          <el-cascader v-model="selectedRegion" :props="props" :show-all-levels="false" placeholder="请选择发布单位" clearable style="width: 250px;"></el-cascader>
                  </span><span style="margin-left: 10px;">
          <!--<el-cascader :options="departOption" v-model="selecteddepartOption" clearable  placeholder="请选择发布单位" style="width: 150px;"></el-cascader>-->
                </span>
                          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="initData(1)">搜索</el-button></div></h2>
                        <ul v-if="listData && listData.length>0">
                          <li  v-for="(item,index) in listData" :key="index" @click="seeShare('PolicyDetail',{detail_id:item.data_id})" >
                            <a  href="javascript:void(0)">
                              <dt style="height: 90px"><h3><img src="../../static/images/policy_sign6.png"></h3><p>{{item.policy_date}}</p></dt>
                              <dd style="height: 90px;padding-top: 10px;">
                                <div style="height: 24px;line-height: 20px;font-size: 12px;border-bottom: 1px solid #d7d6d6;"><span style="font-weight: 600">文号：</span>{{item.policy_number}}&nbsp; &nbsp;<span style="font-weight: 600;margin-left: 50px;">发布单位：</span>{{item.party_name}}</div>
                                <h4 style="margin-top: 10px;">{{item.title}} </h4>
                                <div style="width:100%;height:48px;    color: #888888;line-height:24px;font-size: 12px;overflow:hidden;text-overflow:ellipsis">{{item.policy_abstract}}</div>
                              </dd>
                            </a>
                          </li>
                        </ul>
                        <ul v-else>
                          <div style="text-align: center;font-size: 14px; color: rgb(155 159 162);">
                            <div><img src="../../static/images/empty-image-default.png" style="width: 300px;" /></div>
                            <div>暂无数据</div>
                          </div>
                        </ul>
                        <div class="clear"></div>
                      </div>
                      <div style="text-align: center;height: 50px;line-height: 50px;"> <el-pagination
                        layout="prev, pager, next"
                        :total="pageTotal" :page-size="pageSize" @current-change="pageChange" @prev-click="prevClick" :hide-on-single-page="true" @next-click="nextClieck">
                      </el-pagination>
                      </div>
                    </div>
                  </div>

                </el-tab-pane>
         <!--       <el-tab-pane label="资金标准" name="second">
                  <div style="padding-bottom: 20px">


                  <span>单位：
          <el-cascader @change="zjList(1)" v-model="selectedRegion" :props="props" :show-all-levels="false"   clearable placeholder="请选择区划" style="width: 180px;margin-right: 10px;"/>
                    &lt;!&ndash;<el-cascader :options="departOption" v-model="selecteddepartOption" clearable  placeholder="办事单位" style="width: 180px;display: none"></el-cascader>&ndash;&gt;
          </span>
                  <span   style="margin-left: 15px;">业务类别：
           <el-cascader @change="zjList(1)" :options="archList" v-model="archType" clearable  placeholder="业务类别" style="width: 120px;" ></el-cascader></span>
                    <span   style="margin-left: 15px;">资金分类：
           <el-cascader @change="zjList(1)" :options="typeList" v-model="zjTypeData" clearable  placeholder="资金分类" style="width: 120px;" ></el-cascader></span>
                    <span    style="margin-left: 15px;">对象分类：
           <el-cascader @change="zjList(1)"  :options="personList" v-model="personType" clearable  placeholder="对象分类" style="width: 120px;" ></el-cascader></span>

                  </div>
                  <template>
                    <el-table
                      :data="listDataZj"
                      border
                      style="width: 100%">
                      <el-table-column
                        prop="partyId"
                        label="单位"
                       >
                      </el-table-column>
                      <el-table-column
                        prop="archiveName"
                        label="业务类别"
                       >
                      </el-table-column>
                      <el-table-column
                        prop="className"
                        label="资金分类"
                      width="130px">
                      </el-table-column>
                      <el-table-column
                        prop="personType"
                        label="对象分类">
                      </el-table-column>
                      <el-table-column
                        prop="frequency"
                        label="发放周期"
                      width="80px">
                      </el-table-column>
                      <el-table-column
                        prop="money"
                        label="标准金额"
                      width="100px">
                      </el-table-column>
                      <el-table-column
                        prop="address"
                        label="相关政策">
                        <template slot-scope="scope" v-if="scope.row.policyMap!=[]&&scope.row.policyMap!=''">
                          <a style="color: #2c62ec" :title="items.title" href="javascript:void(0)" @click="seeShare('PolicyDetail',{detail_id:items.id})" v-for="(items,index) in scope.row.policyMap">
                            {{items.title  | ellipsis}}
                          </a>

                        </template>
                      </el-table-column>
                    </el-table>
                  </template>
                  <div v-if="listDataZj.length>0 && listDataZj" style="text-align: center;padding-top: 30px" class="block">
                  <el-pagination
                    layout="prev, pager, next"
                    :total="zjTotal" :page-size="zjPageSize" @current-change="pageZjChange" @prev-click="prevZjClick" @next-click="nextZjClieck">
                  </el-pagination>
                  </div>
                </el-tab-pane>-->
               <!-- <el-tab-pane label="办事指南" name="second">
                  <div class="notice_con" style="width: 1000px">
                  </div>
                </el-tab-pane>-->
                <el-tab-pane v-if="item.type!=='guide'"   v-for="(item,index)  in listDataType" :label="item.name" :name="item.type" :key="index+'a'">
                  <div class="policy_right2" >
               <!--   <ul style="padding-top: 0px;padding-bottom: 0px" v-for="(item,index) in knowListData">
                  <li  @click="seeShare('KnowDetail',{detail_id:item.id,name:knowName,type:item.saveType})">
                    <a href="javascript:void(0)">
                      <dt><br/><p >{{item.date}}</p></dt>
                      <dd >
                        <div  style="white-space:nowrap">
                          <h4>{{item.title}} <span style="float: right;color: #9d9d9d;font-size: 14px">发布单位：{{item.unit}}</span></h4>
                        </div>
                        <p>{{item.abstract}}</p>
                      </dd>
                    </a>
                  </li>
                  </ul>-->
                    <ul v-if="knowListData && knowListData.length>0">
                      <li  v-for="(item,index) in knowListData" :key="index" @click="seeShare('KnowDetail',{detail_id:item.id,name:knowName,type:item.saveType})" >
                        <a  href="javascript:void(0)">
                          <dt style="height: 90px"><h3><img src="../../static/images/policy_sign6.png"></h3><p>{{item.date}}</p></dt>
                          <dd style="height: 90px;padding-top: 10px;">
                            <div style="height: 24px;line-height: 20px;font-size: 12px;border-bottom: 1px solid #d7d6d6;"><span style="font-weight: 600;">发布单位：</span>{{item.unit}}</div>
                            <h4 style="margin-top: 10px;">{{item.title}} </h4>
                            <div  style="width:100%;height:48px;    color: #888888;line-height:24px;font-size: 12px;overflow:hidden;text-overflow:ellipsis">{{item.abstract}}</div>
                          </dd>
                        </a>
                      </li>
                    </ul>
                    <div class="clear"></div>

                  </div>


                  <div v-if="knowListData.length>0 && knowListData" style="text-align: center;padding-top: 30px" class="block">

                    <el-pagination
                      layout="prev, pager, next"
                      :total="knowListTotal" :page-size="knowPageSize" @current-change="pageKnowChange" @prev-click="prevKnowClick" @next-click="nextKnowClieck">
                    </el-pagination>
                  </div>

                    <div v-else style="text-align: center;font-size: 14px; color: rgb(155 159 162);">
                      <div><img src="../../static/images/empty-image-default.png" style="width: 300px;" /></div>
                      <div>暂无数据</div>
                    </div>

                </el-tab-pane>


              </el-tabs>
            </template>
          </div>

        </div>

      </div>
    </div>
    <div class="clear"></div>
    <footers></footers>

  </div>
</template>

<script>
import headers from "../components/Headers";
import fixedDiv from "../components/FixedDiv";
import footers from "../components/Footer";
export default {
  name: "public-index",
  components:{
    headers,fixedDiv,footers
  },
  filters: {
    ellipsis (value) {
      if (!value) return ''
      if (value.length > 10) {
        return value.slice(0,10) + '...'
      }
      return value
    }
  },

  data() {
    let _self=this;
    return {
     zjPageNum:1,
      archType:'',
      partyId:'',
      zjTypeData:'',
      personType:'',
      zjPageSize:10,
      dylbOption:"",
      options:[],
      active: 'publicIndex',
      width:document.body.clientWidth+'px',
      height:document.body.clientHeight+'px',
      props: {
        lazy: true,
        checkStrictly:true,
        lazyLoad (node, resolve) { const { level } = node;
          var t=0;
          if(!node.value){
            node.value=_self.$cookies.get("areaRoot");
            t=1;
            //上级为空，默认设置大通县数据
          }
          const options={pid:node.value}
          _self.$https.post("api/pu/getAreaByParentCode.do",options,response=>{
            const nodes =[];
            // if(t==0) {
            //   if(node.value=='63010001'){
            //     const nodes =[{label:'大通县',value:'6301210001',level:0, leaf: level >= 3}];
            //     resolve(nodes);
            //   }else{
                if (response.status === 200 && response.data.code === 200) {
                  const nodes = Object.values(response.data.data).map(function (e) {
                    return {label: e.name, value: e.code, level: 0, leaf: level >= 1}
                  })
                  resolve(nodes);
                } else {
                  resolve(nodes);
                }
              // }
            // }else{
            //   // const nodes =[{label:'大通县',value:'6301210001',level:0, leaf: level >= 2}];
            //   // resolve(nodes);
            //   const nodes =[{label:'西宁市',value:'63010001',level:0, leaf: level >= 2}];
            //   resolve(nodes);
            // }
          })
        }
      },
      treeData:[],
      defaultProps: {
        children: 'children',
        label: 'text'
      },
      listData:[],
      searchTitle:'',
      pageNum:1,
      pageSize:6,
      knowListData:[],
      tableData:[],
      knowListTotal:0,
      selectedRegion:[],
      selecteddepartOption:[],
      departOption:[],
      listDataType:[],
      listDataZj:[],
      typeList:[],
      archList:[],
      personList:[],
      selecteddylbOption:[],
      qry_archive_type:'',
      qry_policy_type:'',
      qry_policy_grade:'',
      knowName:'',
      pageTotal:0,
      zjTotal:0,
      activeName: 'first',
      knowPageSize:10,
      knowPageNum:1,
      knowType:'',


    }
  } ,
  watch: {
    width(n,o){
      alert(n+'w')
    },
    height(n,o){
      alert(n+'h')
    },
  // selectedRegion(nv){
  //   this.getDepartAreas(nv[nv.length-1],0);
  // }
  },
  created(){
    let id = this.$route.query.id;
    if (id!="" && id!=undefined){
      this.gotoDetail(id)
    }
    var areaInfo = this.$cookies.get('areaInfo')
      if(areaInfo && areaInfo.length>0){
    this.partyId=areaInfo.departyId[areaInfo.departyId.length-1]
      }
    this.initRootTree();
    this.initType();
    this.initData(1);
    this.browseLog('bmcx','zccx');
  },
  methods: {
    gotoDetail(detail_id){
      this.$router.push({path:'PolicyDetail',query:{detail_id:detail_id}})
    },
     handleClick(tab, event) {
      if (tab.name==this.knowType){

      }else {
        if (tab.name=='first'){
          this.browseLog('bmcx','zccx');
        }else if (tab.name=='second'){
          this.zjPageSize=10;
          this.zjPageNum=1;
          this.zjList();
          this.zjType();
          this.browseLog('bmcx','zjbzcx');
        }else {
          this.knowPageSize=10;
          this.knowPageNum=1;
          this.knowType=tab.name
          this.knowName=tab.label
          this.browseLog('bmcx','zscx');
          this.getListByType();
        }
      }

    },
    browseLog(one,two){
      const options={
        oneCode:one,
        twoCode:two,
      }
      this.$https.post("api/browse/saveBrowseLog.do",options,response=>{
      })
    },
    initType(){
      var t=this;
      const options={
        type:'knowledge'
      }
      this.$https.post("api/policy/getPolicyType.do",options,response=>{
        if (response.status === 200 && response.data.code===200) {
          if(response.data.data.data && response.data.data.data.length>0){
            t.listDataType=response.data.data.data;
          }else {
            t.listDataType=[]
          }
        } else {

          // t.departOption =[];
        }
      })
    },
    zjList(value){
      if (value==1){
        this.zjPageNum=1;
        this.listDataZj=[];
        this.archList=[];
        this.typeList=[];
        this.personList=[];
        this.zjType();
      }
      var t=this;
      var partyId="";
      if(this.selectedRegion && this.selectedRegion.length>0){
        this.partyId=this.selectedRegion[this.selectedRegion.length-1];
      }
      var archType="";
      if(this.archType && this.archType.length>0){
        archType=this.archType[this.archType.length-1];
      }
      var zjTypeData="";
      if(this.zjTypeData && this.zjTypeData.length>0){
        zjTypeData=this.zjTypeData[this.zjTypeData.length-1];
      }
      var personType="";
      if(this.personType && this.personType.length>0){
        personType=this.personType[this.personType.length-1];
      }

      const options={
        title:this.searchTitle,
        partyId:this.partyId,
        pageSize:this.zjPageSize,
        pageNum:this.zjPageNum,
        archType:archType,
        zjTypeData:zjTypeData,
        personType:personType,
      }

      this.$https.post("api/policy/getZjList.do",options,response=>{
        if (response.status === 200 && response.data.code===200) {
          if(response.data.data.listData && response.data.data.listData.length>0){
            t.listDataZj=response.data.data.listData;
            t.zjTotal=response.data.data.total;

          }else {
            t.listDataZj=[]
          }
        } else {
          // t.departOption =[];
          t.listDataZj=[]
        }
      })
    },
    zjType(){
      var partyId="";
      if(this.selectedRegion && this.selectedRegion.length>0){
        this.partyId=this.selectedRegion[this.selectedRegion.length-1];

      }
      var archType="";
      if(this.archType && this.archType.length>0){
        archType=this.archType[this.archType.length-1];
      }
      var t=this;
      this.$https.post("api/policy/getZjType.do",{partyId:this.partyId, archType:archType},response=>{
        if (response.status === 200 && response.data.code===200) {

            t.typeList=response.data.data.listData;
            t.archList=response.data.data.archList;
            t.personList=response.data.data.personList;



        } else {

        }
      })
    },
    initData(tts){
      if(tts){
        this.pageNum=1;
      }
      var partyId="";
      if(this.selectedRegion && this.selectedRegion.length>0){
        partyId=this.selectedRegion[this.selectedRegion.length-1];
      }
      const options={
        partyId:partyId,
        pageSize:this.pageSize,
        pageNum:this.pageNum,
        searchTitle:this.searchTitle,
        qry_archive_type:this.qry_archive_type,
        qry_policy_type:this.qry_policy_type,
        qry_policy_grade:this.qry_policy_grade
      }
      var t=this;

      this.$https.post("api/policy/getPolicyList.do",options,response=>{
        if (response.status === 200 && response.data.code===200) {
          if(response.data.data.listData && response.data.data.listData.length>0){
            t.listData=response.data.data.listData;
          }else {
            t.listData=[]
          }
          t.pageTotal=response.data.data.total;

        } else {
          // t.departOption =[];
        }
      })
    },
    prevZjClick(a){
      this.zjPageNum=this.zjPageNum-1;
      this.zjList();
    },
    nextZjClieck(a){
      this.zjPageNum=this.zjPageNum+1;
      this.zjList();
    },

    pageZjChange(a){
      this.zjPageNum=a
      this.zjList(a);
    },
    prevKnowClick(a){
      this.pageKnowNum=this.pageKnowNum-1;
      this.initData();
    },
    nextKnowClieck(a){
      this.pageKnowNum=this.pageKnowNum+1;
      this.initData();
    },

    pageKnowChange(a){
      this.pageKnowNum=a

      this.getListByType(a);
    },
    prevClick(a){

      this.pageNum=this.pageNum-1;
      this.getListByType(a);
    },
    nextClieck(a){

      this.pageNum=this.pageNum+1;
      this.getListByType(a);

    },
    search(){
      this.initData(1);
      this.getListByType()
      this.zjList();
    },
    pageChange(a){
      this.pageNum=a
      this.initData();
    },
    handleNodeClick(data){
      if(data.children && data.children.length>0){
        this.qry_archive_type = '';
        this.qry_policy_type = '';
        this.qry_policy_grade =  '';
        console.log(data);
        return;
      }
      if(data.attributes.type=='qry_archive_type'){
        if(this.qry_archive_type !=data.id){
          this.qry_archive_type=data.id;
          this.qry_policy_type='';
          this.qry_policy_grade='';
          this.initData(1);
          console.log(data);
        }
      }else if(data.attributes.type=='qry_policy_type'){
        if(this.qry_policy_type !=data.id) {
          this.qry_archive_type = '';
          this.qry_policy_type = data.id;
          this.qry_policy_grade = '';
          this.initData(1);
          console.log(data);
        }
      }else if(data.attributes.type=='qry_policy_grade'){
        if(this.qry_policy_grade !=data.id) {
          this.qry_archive_type = '';
          this.qry_policy_type = '';
          this.qry_policy_grade =  data.id;
          this.initData(1);
          console.log(data);
        }
      }else{
        this.qry_archive_type = '';
        this.qry_policy_type = '';
        this.qry_policy_grade =  '';
        this.initData(1);
        console.log(data);
      }
    },
    initRootTree(){
      this.$https.post("api/policy/getQryConditionTreeData.do",{},response=>{
        if (response.status === 200 && response.data.code===200) {
          this.treeData=response.data.data;
        } else {
        }
      })
    },
    getListByType(a){
      this.knowPageNum=a;
      this.$https.post("api/policy/getKnowledgeList.do",{type:this.knowType,pageSize:this.knowPageSize,pageNum:this.knowPageNum,title:this.searchTitle},response=>{
        if (response.status === 200 && response.data.code===200) {
          this.knowListData = response.data.data.listData;
          this.knowListTotal = response.data.data.total;
        } else {

        }
      })
    },
    seeShare(url,d){
      let routeUrl = this.$router.resolve({
        path: "/"+url,
        query: d
      });
      window.open(routeUrl.href, '_blank');
    },
    getDepartAreas(ParentId,index){
      const options={pid:ParentId}
      var t=this;
      this.$https.post("api/pu/getPartyByParentAreaCode.do",options,response=>{
        if (response.status === 200 && response.data.code===200) {
          t.departOption = Object.values(response.data.data).map(function(e){
            return {label:e.name,value:e.code,leaf:true}
          })
        } else {
          t.departOption =[];
        }
      })
    },
    getKnowContent(id){

      this.$router.push({path:'KnowDetail',query:{detail_id:id,name:this.knowName}})

     /* this.$https.post("api/policy/getKnowledgeDeta.do",{id},response=>{
        if (response.status === 200 && response.data.code===200) {

        } else {
        }
      })*/

    },
    urlTo(url,params){
      this.$router.push({path:url,query:params||{}});
    }
  }
}



</script>
<style>
  .publicity table td {
    padding: 0px 5px;
  }
  .policy_left2 .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
    background-color: #3f76ea;
    color: white;
  }
  .aaa .el-tabs__item{
    padding: 0 20px;
    height: 60px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    line-height: 60px;
    display: inline-block;
    list-style: none;
    font-size: 16px;
    font-weight: 500;
    color: #303133;
    position: relative;
  }
  body .el-table th.gutter {
    display: table-cell !important;  /*解决el-table表格边框不对齐错行,引起的原因：渲染完el-table后，对其进行宽度、高度的计算重新渲染*/
  }
</style>



// WEBPACK FOOTER //
// src/pages/PolicyServiceIndex.vue